import React, { FC } from 'react';
import Helmet from 'react-helmet';
import { CDN_ORIGIN_ENDPOINT } from '../../../../../shared/cdn';
import { SHARE_IMAGE_URL } from './headConstants';

type Props = {
  title?: string;
  url: string;
  description?: string;
};

export const HeadOpenGraph: FC<Props> = ({ title, url, description }) => (
  <Helmet>
    <meta property="og:locale" content="fr_FR" />
    <meta property="og:type" content="website" />
    <meta property="og:title" content={title} />
    <meta property="og:url" content={url} />
    <meta property="og:description" content={description} />
    <meta property="og:site_name" content="Doctrine" />
    <meta
      property="og:image"
      content={`${CDN_ORIGIN_ENDPOINT}${SHARE_IMAGE_URL}`}
    />
    <meta
      property="og:image:secure_url"
      content={`${CDN_ORIGIN_ENDPOINT}${SHARE_IMAGE_URL}`}
    />
  </Helmet>
);
